<template>
    <solid-box title="集体经营性资产">
        <div class="list">
            <el-tabs v-model="activeName" @tab-click="tabClick">
                <el-tab-pane
                    v-for="item in list"
                    :label="item.title"
                    :name="item.name"
                    :key="item.type"
                ></el-tab-pane>
            </el-tabs>
            <el-carousel
                arrow="never"
                ref="carousel"
                indicator-position="none"
                @change="tabChange"
            >
                <el-carousel-item
                    v-for="item in list"
                    :name="item.name"
                    :key="item.type"
                >
                    <div class="item-wrap">
                        <div class="item _item1">
                            <div class="label">
                                {{ item.label1 }}
                            </div>
                            <div class="number">
                                {{ tradeSum.jtjyxzcq[item.key[0]] || 0 }}
                                <span class="unit">{{ item.unit1 }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-wrap">
                        <div class="item _item2">
                            <div class="label">
                                {{ item.label2 }}
                            </div>
                            <div class="number">
                                {{ tradeSum.jtjyxzcq[item.key[1]] || 0 }}
                                <span class="unit">{{ item.unit2 }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-wrap">
                        <div class="item _item3">
                            <div class="label">
                                {{ item.label3 }}
                            </div>
                            <div class="number">
                                {{ tradeSum.jtjyxzcq[item.key[2]] || 0 }}
                                <span class="unit">{{ item.unit3 }}</span>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'

/**
 * 集体经营性资产
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        SolidBox
    },
    data() {
        return {
            activeName: '',
            list: [
                {
                    key: ['FW_area', 'FW_publish_area', 'FW_sumAreas'],
                    title: '房屋建筑',
                    name: '0',
                    type: 'FW',
                    label1: '确权数量',
                    label2: '挂牌数量',
                    label3: '成交数量',
                    unit1: '平方米',
                    unit2: '平方米',
                    unit3: '平方米'
                },
                {
                    key: ['JQSB_permission', 'JQSB_publish', 'JQSB_transfer'],
                    title: '机器设备',
                    name: '1',
                    type: 'JQSB',
                    label1: '确权数量',
                    label2: '挂牌数量',
                    label3: '成交数量',
                    unit1: '台',
                    unit2: '台',
                    unit3: '台'
                },
                {
                    key: ['QT_permission', 'QT_publish', 'QT_transfer'],
                    title: '其他生产',
                    name: '2',
                    type: 'QT',
                    label1: '确权数量',
                    label2: '挂牌数量',
                    label3: '成交数量',
                    unit1: '个',
                    unit2: '个',
                    unit3: '个'
                }
            ]
        }
    },
    methods: {
        tabChange(val) {
            this.activeName = val + ''
        },
        tabClick() {
            this.$refs.carousel.setActiveItem(this.activeName)
        }
    }
}
</script>

<style scoped>
/deep/ .el-tabs__nav-wrap::after {
    background: unset;
}
/deep/ .el-tabs__header {
    margin-bottom: 10px;
}
/deep/ .el-tabs__item {
    font-size: 18px;
    color: #40b9f6;
    padding: 0 8px;
}
/deep/ .el-tabs__item.is-active {
    color: #40b9f6;
}
/deep/ .el-tabs__content {
    background: #007aff;
}
/deep/ .el-tabs__nav {
    float: right;
}
/deep/ .el-carousel__container {
    height: 190px;
}
</style>
<style lang="scss" scoped>
.hader {
    font-size: 18px;
    color: #ffffff;
    margin: 14px auto 0;
    width: 154px;
    height: 25px;
    line-height: 25px;
    background-size: 100% 5px;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url('../../../assets/images/collective_management_head_bg.png');
    text-align: center;
}

.list {
    width: calc(100% - 80px);
    padding: 0 40px;
    .item {
        margin-bottom: 14px;
        width: 100%;
        height: 50px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        padding: 10px 25px 0 35px;
        box-sizing: border-box;
        &._item1 {
            background-image: url('../../../assets/images/collective_management_item_bg1.png');
        }
        &._item2 {
            background-image: url('../../../assets/images/collective_management_item_bg2.png');
        }
        &._item3 {
            background-image: url('../../../assets/images/collective_management_item_bg3.png');
        }
        > .label {
            font-size: 16.54px;
            color: #ffffff;
            line-height: 24px;
        }

        > .number {
            margin-left: auto;
            display: flex;
            align-items: center;
            font-size: 24px;
            color: #ffffff;
            text-align: right;
            line-height: 30px;

            > .unit {
                font-size: 14px;
                color: #ffffff;
                text-align: justify;
                line-height: 30px;
                margin-left: 4px;
            }
        }
    }
}
</style>
